"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _prefixUrl = require("@mapbox/batfish/modules/prefix-url");

var _routeTo = require("@mapbox/batfish/modules/route-to");

var _example = _interopRequireDefault(require("../../components/example"));

var _directions = _interopRequireDefault(require("./directions.html"));

var _pageShell = _interopRequireDefault(require("/home/toannc/ekmap-platform-map-javascript/docs/components/page-shell.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var frontMatter = {
  title: 'Công cụ chỉ đường',
  description: 'Sử dụng ekmap-platform-directions để tích hợp công cụ chỉ đường.',
  topics: ['Directions', 'Controls'],
  thumbnail: 'control_direction',
  order: 4,
  contentType: 'example',
  layout: 'page',
  hideFeedback: false,
  language: ['JavaScript'],
  products: ['Mapbox GL JS'],
  headings: []
};

var MarkdownReact = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(MarkdownReact, _React$PureComponent);

  var _super = _createSuper(MarkdownReact);

  function MarkdownReact() {
    _classCallCheck(this, MarkdownReact);

    return _super.apply(this, arguments);
  }

  _createClass(MarkdownReact, [{
    key: "render",
    value: function render() {
      var props = this.props;
      return /*#__PURE__*/_react["default"].createElement(_pageShell["default"], _extends({}, props, {
        frontMatter: frontMatter
      }), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("p", null, "V\xED d\u1EE5 n\xE0y th\xEAm c\xF4ng c\u1EE5 ch\u1EC9 \u0111\u01B0\u1EDDng tr\xEAn b\u1EA3n \u0111\u1ED3."), /*#__PURE__*/_react["default"].createElement("p", null, "S\u1EED d\u1EE5ng th\u01B0 vi\u1EC7n ", /*#__PURE__*/_react["default"].createElement("a", {
        href: "https://files.ekgis.vn/sdks/v2.0.0/ekmap-platform-directions.js"
      }, "ekmap-platform-directions"), ", sau \u0111\xF3 s\u1EED d\u1EE5ng map.addControl \u0111\u1EC3 th\xEAm \u0111i\u1EC1u khi\u1EC3n v\u1EDBi Directions \u0111\u01B0\u1EE3c x\xE1c \u0111\u1ECBnh trong c\xE1c t\xF9y ch\u1ECDn. "), /*#__PURE__*/_react["default"].createElement(_example["default"], _extends({
        html: _directions["default"]
      }, this.props))));
    }
  }]);

  return MarkdownReact;
}(_react["default"].PureComponent);

exports["default"] = MarkdownReact;